import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Button, Row, Col } from 'antd';
import InputForm from 'components/Form/InputForm';
import { contentRsg } from '@/utils/common/constants';
import cx from 'classnames';
import './style/index.less';

class OrgFormModal extends Component {
  static propTypes = {
    title: PropTypes.string,
    selfRecord: PropTypes.object,
    parentRecord: PropTypes.object,
    visible: PropTypes.bool,
    columns: PropTypes.array,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    modalOpts: PropTypes.object,
    formOpts: PropTypes.object,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      visible: this.props.visible,
      assignClientFlow: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if ('visible' in nextProps) {
      this.setState({
        visible: nextProps.visible
      });
    }
  }

  closeModal = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
      return;
    }
    this.setState({
      visible: false
    });
  };

  onSubmit = () => {
    const { selfRecord, parentRecord, onSubmit } = this.props;
    this.props.form.validateFields((error, value) => {
      if (error) {
        // console.log(error);
        return;
      }
      onSubmit && onSubmit(value, selfRecord, parentRecord);
    });
  };
  selectOrgCallBack = (pid, pName, level) => {
    this.setState({
      pid: pid,
    }, () => {
      this.props.form.setFieldsValue({
        "parentid": pid,
        "prePid": pid,
        "level": level + 1,
      });
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const {
      title,
      selfRecord,
      parentRecord,
      className,
      onCancel,
      onSubmit,
      modalOpts,
      size,
      loading,
      full,
      form
    } = this.props;


    let orgProps = {
      showSearch: true,
      //style: { width: 300 },
      style: { width: 265 },
      dropdownStyle: { maxHeight: 400, overflow: 'auto' },
      // placeholder: "请选择机构",
      //allowClear: true,
      treeDefaultExpandAll: true,
      selectOrgCallBack: this.selectOrgCallBack,
    };


    const classname = cx(className, 'antui-modalform', 'orgFormModal', 'show-modal', { 'full-modal': full });
    const modalProps = {
      className: classname,
      confirmLoading: loading,
      visible: this.state.visible,
      title: title || (selfRecord ? window.language['common.update'] : window.language['common.add']),
      maskClosable: false,
      destroyOnClose: true,
      size,
      onCancel: this.closeModal,
      footer: [
        onCancel && (
          <Button key="back" onClick={this.closeModal}>
            {window.language['common.cancel']}
          </Button>
        ),
        onSubmit && (
          <Button key="submit" type="primary" onClick={this.onSubmit}>
            {window.language['common.ok']}
          </Button>
        )
      ],
      ...modalOpts
    };

    //form表单样式
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 }
    };

    return (
      <Modal {...modalProps}>
        <Row>
          <Form.Item {...formItemLayout} style={{ marginBottom: 0 }}>
            {InputForm({
              form,
              type: 'hidden',
              name: 'id',
              initialValue: selfRecord ? selfRecord.key : null
            })}
          </Form.Item>
          <Form.Item {...formItemLayout} style={{ marginBottom: 0 }}>
            {InputForm({
              form,
              type: 'hidden',
              name: 'parentId',
              initialValue: parentRecord ? parentRecord.key : null
            })}
          </Form.Item>
          <Form.Item {...formItemLayout} style={{ marginBottom: 0 }}>
            {InputForm({
              form,
              type: 'hidden',
              name: 'level',
              initialValue: parentRecord ? parseInt(parentRecord.level) + 1 : null
            })}
          </Form.Item>
          <Form.Item {...formItemLayout} label={window.language['org.parentOrg']}>
            {InputForm({
              form,
              type: 'input',
              name: 'parentName',
              initialValue: parentRecord ? parentRecord.title : null,
              style: { width: 265 },
              maxLength: '20',
              autoComplete: 'off',
              disabled: true
            })}
          </Form.Item>
        </Row>
        <Row>
          <Form.Item {...formItemLayout} label={window.language['org.name']}>
            {InputForm({
              form,
              type: 'input',
              name: 'name',
              initialValue: selfRecord ? selfRecord.title : null,
              style: { width: 265 },
              placeholder: window.language['common.inputContent'],
              maxLength: '20',
              autoComplete: 'off',
              rules: [{
                required: true,
                message: window.language['common.inputContent']
              }, {
                pattern: contentRsg,
                message: window.language['common.notSpecialChar']
              }]
            })}
          </Form.Item>
        </Row>
        <Row>
          <Form.Item {...formItemLayout} label={window.language['org.remark']}>
            {InputForm({
              form,
              type: 'textarea',
              name: 'remark',
              initialValue: selfRecord ? selfRecord.remark : null,
              style: { width: 265, height: 100, resize: "none", borderRadius: '4px' },
              placeholder: window.language['common.inputRemarkContent'].replace("{1}", 100),
              maxLength: '100',
              autoComplete: 'off',
              rules: [{
                required: false,
                message: window.language['common.inputContent']
              }]
            })}
          </Form.Item>
        </Row>
      </Modal>
    );
  }
}

export default Form.create()(OrgFormModal);



// WEBPACK FOOTER //
// ./src/routes/System/Org/components/OrgFormModal.js